module.exports = __webpack_public_path__ + "img/win_paytable.06fe10ad.png";